import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { API_URL } from "./config";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true); // Loading state add kiya
  const navigate = useNavigate();

  const showHome = () => {
    navigate("/");
  };

  const checkAuth = async () => {
    try {
      console.log("Checking auth...");
      const response = await fetch(`${API_URL}/api/user`, {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      
      console.log("Response status:", response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log("User data:", data);
        setIsLoggedIn(true);
      } else {
        console.log("Not logged in");
        setIsLoggedIn(false);
      }
    } catch (error) {
      console.log("Auth check error:", error);
      setIsLoggedIn(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const handleLogout = async () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (confirmLogout) {
      try {
        const response = await fetch(`${API_URL}/api/logout`, {
          method: "POST",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          setIsLoggedIn(false);
          navigate("/login");
        } else {
          console.error("Logout failed");
        }
      } catch (error) {
        console.error("Logout failed", error);
      }
    }
  };

  // Loading state - jab tak auth check ho raha hai
  if (loading) {
    return (
      <div style={styles.headerWrapper}>
        <div className="container">
          <header style={styles.header}>
            <img
              onClick={showHome}
              src="https://suggestcrm.com/vendor/adminlte/dist/img/AdminLTELogo.png"
              alt="Logo"
              style={styles.title}
            />
            <button className="menu-btn" style={styles.menuButton}>
              ☰
            </button>
          </header>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.headerWrapper}>
      <div className="container">
        <header style={styles.header}>
          <img
            onClick={showHome}
            src="https://suggestcrm.com/vendor/adminlte/dist/img/AdminLTELogo.png"
            alt="Logo"
            style={styles.title}
          />

          <button
            onClick={() => setIsOpen(!isOpen)}
            style={styles.menuButton}
            className="menu-btn"
          >
            {isOpen ? "✖" : "☰"}
          </button>

          <nav
            className={`nav-menu ${isOpen ? "open" : ""}`}
            style={{
              ...styles.nav,
            }}
          >
            <NavLink
              to="/about"
              style={({ isActive }) =>
                isActive
                  ? { ...styles.link, ...styles.activeLink }
                  : styles.link
              }
              onClick={() => setIsOpen(false)}
            >
              About
            </NavLink>

            {!isLoggedIn && (
              <NavLink
                to="/login"
                style={({ isActive }) =>
                  isActive
                    ? { ...styles.link, ...styles.activeLink }
                    : styles.link
                }
                onClick={() => setIsOpen(false)}
              >
                Login
              </NavLink>
            )}
            
            {isLoggedIn && (
              <button onClick={handleLogout} style={styles.logoutButton}>
                Logout
              </button>
            )}
          </nav>
        </header>
      </div>
    </div>
  );
}

const styles = {
  headerWrapper: {
    backgroundColor: "#032d57ff",
    position: "sticky",
    top: "0px",
    zIndex: "99",
    width: "100%",
  },
  header: {
    padding: "10px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },
  title: {
    width: "50px",
    height: "50px",
    borderRadius: "10px",
    cursor: "pointer",
    objectFit: "contain",
  },
  nav: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
  },
  link: {
    color: "white",
    textDecoration: "none",
    fontSize: "16px",
    padding: "8px 12px",
    borderRadius: "4px",
    transition: "all 0.3s ease",
  },
  activeLink: {
    borderBottom: "2px solid white",
  },
  menuButton: {
    fontSize: "24px",
    background: "none",
    border: "none",
    color: "white",
    cursor: "pointer",
    display: "none",
  },
  logoutButton: {
    backgroundColor: "white",
    color: "#032d57ff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    padding: "8px 20px",
    fontSize: "16px",
    fontWeight: "500",
    transition: "all 0.3s ease",
  },
};

// CSS for responsive design
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @media (max-width: 768px) {
    .menu-btn {
      display: block !important;
    }
    
    .nav-menu {
      position: fixed;
      top: 70px;
      left: -100%;
      width: 100%;
      height: calc(100vh - 70px);
      background-color: #032d57ff;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      transition: left 0.3s ease;
      z-index: 999;
    }
    
    .nav-menu.open {
      left: 0;
    }
    
    .nav-menu a, 
    .nav-menu button {
      width: 200px;
      text-align: center;
      margin: 10px 0;
    }
  }
  
  @media (min-width: 769px) {
    .menu-btn {
      display: none !important;
    }
    
    .nav-menu {
      display: flex !important;
      flex-direction: row !important;
      position: static !important;
      height: auto !important;
      background-color: transparent !important;
      padding: 0 !important;
    }
  }
`;
document.head.appendChild(styleSheet);

export default Header;